import { queryBuilderCacheSlice } from "@bikdotai/bik-component-library";
import botStore from "../../../../state/store";

// Cache keys the library QueryBuilder fills for every builder in the session.
// Builders serve different lists under the same key (the anniversary modal
// returns only date custom fields and three user properties), so each builder
// clears them before it mounts.
export const SHARED_QUERY_BUILDER_CACHE_KEYS = ["CUSTOM_FIELDS", "USER_PROPERTIES"];

export const clearSharedQueryBuilderCache = () => {
  botStore.dispatch(
    queryBuilderCacheSlice.actions.clearKeys(SHARED_QUERY_BUILDER_CACHE_KEYS)
  );
};
